export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_04_10_20.Still011.76dacf7a.jpg";